import { GLServiceBase, ServiceRoute } from "commonui";
import { IAuditHistoryService } from "./interface";
import { AuditHistoryModel, AuditHistoryResponseModel } from "./model";

class AuditHistoryServiceClass extends GLServiceBase<any, any> implements IAuditHistoryService {
	serviceRoute: ServiceRoute = { prefix: "content/v1/audittraillog" };

	getAuditHistory(pageNumber: number, pageSize: number): Promise<AuditHistoryResponseModel> {
		return this.get({ pageNumber, pageSize });
	}

	getAllAuditHistory(): Promise<AuditHistoryModel[]> {
		return this.get("getAllLogs");
	}
}

export const AuditHistoryService = () => new AuditHistoryServiceClass() as IAuditHistoryService;
